import React, { useEffect, useState } from "react";
import withStyles from "@mui/styles/withStyles";
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import Post from "./Post";
import RepliesFeed from "../reply/RepliesFeed";
import axios from "axios";
import Loading from "../../../../shared/components/Loading";
import jwtDecode from "jwt-decode";
import { Typography } from "@mui/material";

const styles = (theme) => ({
  wrapper: {
    margin: "8rem auto",
    maxWidth: "1000px",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    // gap: theme.spacing(2),
  },
});

const PostDetails = ({ classes, openLoginDialog, selectCommunity }) => {
  const { slug } = useParams();
  const location = useLocation();
  const [post, setPost] = useState(location.state?.post);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const hist = useHistory();
  const goToAuth = () => {
    hist.push("/auth/login");
  };

  const fetchPost = async () => {
    try {
      const response = await axios.get(`/api/socials/posts/${slug}`);
      setPost(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const likePost = async (targetType, targetId) => {
    let req = {
      targetId: targetId,
      targetType: targetType,
    };
    try {
      if (!currentUser) {
        goToAuth();
      } else {
        await axios.post(`/api/socials/likes/create`, req);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    selectCommunity();
    const fetchData = async () => {
      await fetchPost();

      if (localStorage.getItem("jwtToken")) {
        const token = localStorage.getItem("jwtToken");
        const decoded = await jwtDecode(token);
        setCurrentUser(decoded);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div className={classes.wrapper}>
      {loading ? (
        <>
          <Loading item="post" />
        </>
      ) : post ? (
        <>
          <Post post={post} currentUser={currentUser} likePost={likePost} />

          <RepliesFeed
            slug={slug}
            currentUser={currentUser}
            likePost={likePost}
          />
        </>
      ) : (
        <Typography color={"primary"} variant="h4" fontWeight={500}>
          {"Post Not Found ;("}
        </Typography>
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PostDetails);
